"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var omi_1 = require("omi");
var css = require("./index.scss");
var tab_bar_1 = require("@material/tab-bar");
require("../icon");
var dom_ready_1 = require("../util/dom-ready");
//@ts-ignore
require("../theme.ts");
// @ts-ignore
var util_ts_1 = require("../util.ts");
var Tab = /** @class */ (function (_super) {
    __extends(Tab, _super);
    function Tab() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.data = {
            active: null,
            tabBar: null
        };
        return _this;
    }
    Tab.prototype.installed = function () {
        var _this = this;
        dom_ready_1.domReady(function () {
            //update first
            _this.update();
            //init mdc tab
            _this.data.tabBar = new tab_bar_1.MDCTabBar(_this.shadowRoot.querySelector('.mdc-tab-bar'));
            _this.data.tabBar.listen('MDCTabBar:activated', function (e) {
                var item = _this.props.children[e.detail.index];
                _this.fire('change', item.attributes);
            });
        });
    };
    Tab.prototype.uninstall = function () {
        this.data.tabBar.destroy();
    };
    Tab.prototype.activateTab = function (value) {
        // @ts-ignore
        var index = [].findIndex(this.props.children, (function (item) { return item.attributes.value === value; }));
        this.data.tabBar.activateTab(index);
    };
    Tab.prototype.renderButton = function (vnode, activeProp) {
        var props = vnode.attributes;
        //todo fix this?
        if (props['svg-icon']) {
            props.svgIcon = JSON.parse(props['svg-icon'].replace(/(['"])?([a-zA-Z0-9_]+)(['"])?:([^\/])/g, '"$2":$4').replace(/'([\s\S]*?)'/g, '"$1"'));
        }
        var isActive = activeProp === props.value;
        return (omi_1.h("button", __assign({}, omi_1.extractClass(props, 'mdc-tab', {
            'mdc-tab--active': isActive,
            'mdc-tab--min-width': this.props.useMinWidth,
            'mdc-tab--stacked': this.props.stacked
        }), { role: "tab", "aria-selected": isActive }),
            omi_1.h("span", { class: "mdc-tab__content" },
                props.icon && omi_1.h("span", { class: "mdc-tab__icon material-icons", "aria-hidden": "true" }, props.icon),
                props.svgIcon && omi_1.h("span", { class: "mdc-tab__icon", "aria-hidden": "true" },
                    omi_1.h("m-icon", __assign({}, props.svgIcon))),
                omi_1.h("span", { class: "mdc-tab__text-label" }, vnode.attributes.label)),
            omi_1.h("span", __assign({}, omi_1.extractClass(props, 'mdc-tab-indicator', { 'mdc-tab-indicator--active': isActive })),
                omi_1.h("span", { class: "mdc-tab-indicator__content mdc-tab-indicator__content--underline" })),
            omi_1.h("span", { class: "mdc-tab__ripple" })));
    };
    Tab.prototype.render = function (props) {
        var _this = this;
        var defaultActive = props.defaultActive, width = props.width, align = props.align;
        if (this.innerHTML && !props.children) {
            props.children = util_ts_1.htmlToVdom(this.innerHTML);
        }
        var children = props.children;
        var style = { width: width || '100%' };
        var alignClass = align && 'mdc-tab-scroller--align-' + align;
        var scrollerClasses = omi_1.extractClass(props, 'mdc-tab-scroller', alignClass);
        return (omi_1.h("div", { class: "mdc-tab-bar", style: style, role: "tablist" },
            omi_1.h("div", __assign({}, scrollerClasses),
                omi_1.h("div", { class: "mdc-tab-scroller__scroll-area" },
                    omi_1.h("div", { class: "mdc-tab-scroller__scroll-content" }, children && children.map(function (vnode) { return _this.renderButton(vnode, defaultActive); }))))));
    };
    Tab.css = css;
    Tab.propTypes = {
        defaultActive: String,
        width: String,
        align: String,
        useMinWidth: Boolean,
        stacked: Boolean
    };
    Tab = __decorate([
        omi_1.tag('m-tab')
    ], Tab);
    return Tab;
}(omi_1.WeElement));
exports.default = Tab;
